import BaseSettingsApi, { IBasePortalSettings } from 'api/digifi/base/BaseSettingsApi';

interface IIntermediaryPortalConfiguration {
  allowInviteBorrowers: boolean;
}

export interface IIntermediaryPortalSettings extends IBasePortalSettings {
  portalConfiguration: IIntermediaryPortalConfiguration;
}

export default class IntermediarySettingsApi extends BaseSettingsApi<IIntermediaryPortalSettings> {}
